import { useState, type FunctionComponent } from 'react';
import { type ImageFieldsFragment } from '../../../../../__generated__/graphql-client-types';
import { Popover } from '../../../../common-components/popover/popover.component';
import { CloudinaryImage } from '../../../../images/cloudinary-image/cloudinary-image.component';
import HelpCircleIcon from '../../../../svgs/untitled-ui/help-circle.svg';

type ProductOptionsGroupHelpProps = {
	title: string;
	helpText?: string;
	helpImage?: ImageFieldsFragment;
};

export const ProductOptionsGroupHelp: FunctionComponent<ProductOptionsGroupHelpProps> = ({ title, helpText, helpImage }) => {
	const [isHelpOpen, setIsHelpOpen] = useState(false);
	const triggerElement = <HelpCircleIcon data-testid="help-icon" className="pointer f5-ns f6" />;

	return (
		<Popover
			toggleElement={triggerElement}
			isVisible={isHelpOpen}
			setIsVisible={setIsHelpOpen}
			direction="bottom"
			data-automation="product-options-group-help-popover">
			<div className="flex flex-column pa2 f6 w-100 min-w-80 max-w-80 min-[30em]:min-w-105">
				<strong data-automation="product-options-group-help-title">{title}</strong>
				{helpText && (
					<p
						className="ma0 mt1"
						data-automation="product-options-group-help-text"
						dangerouslySetInnerHTML={{ __html: helpText }}
					/>
				)}
				{helpImage && (
					<CloudinaryImage
						publicID={helpImage.id}
						description={helpImage.description}
						className="mw-none"
						options={{ crop: 'limit', width: undefined, height: 400 }}
						data-automation="product-options-group-help-image"
					/>
				)}
			</div>
		</Popover>
	);
};
